import * as types from './types';

const BACKEND_API = 'BACKEND_API';

export const getDirectory = query => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: `/portal_directory/?${query ? 'query=':''}${query||''}`,
    ...types.GET_DIRECTORY
  }
});

export const getDirectoryDetail = (id, query) => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: `/portal_directory/${id}/?${query ? 'query=':''}${query||''}`,
    ...types.GET_DIRECTORY_DETAIL
  }
});
